module.exports = __webpack_public_path__ + "img/TESL-burning-notes-secrets.df990a62.jpg";